import React, { useState, useCallback } from 'react';
import LaddaButton, { XL, SLIDE_UP } from 'react-ladda';
import PropTypes from 'prop-types';

import * as Helpers from '../helpers';
import { Input } from '../components';

const Signup = props => {
  const { signup, history, account: { loading } } = props;
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({
    confirmPassword: '',
    email: '',
    password: '',
    username: '',
  });
  const changeEmail = e => setEmail(e.target.value);
  const changeUsername = e => setUsername(e.target.value);
  const changePassword = e => setPassword(e.target.value);
  const changeConfirmPassword = e => setConfirmPassword(e.target.value);
  const changeError = type => err => setErrors({ ...errors, [type]: err });
  const submit = useCallback(() => {
    const errorText = Object.values(errors).join('\n').replace(/^\s+|\s+$/g, '');
    if (!errorText) {
      signup(email, username, password, history);
    } else {
      Helpers.notification.error(errorText || 'Fill in the form appropraitely.');
    }
  }, [signup, email, username, password, history, errors]);
  const showLoader = loading.some(url => url === 'signup');
  return (
    <div id="background">
      <div className="back" onClick={history.goBack}>Back</div>
      <div>
        <Input
          data-testid="email"
          className="input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={changeEmail}
          onError={changeError('email')}
        />
      </div>
      <div>
        <Input
          data-testid="username"
          className="input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={changeUsername}
          onError={changeError('username')}
        />
      </div>
      <div>
        <Input
          data-testid="password"
          className="input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={changePassword}
          onError={changeError('password')}
        />
      </div>
      <div>
        <Input
          className="input"
          type="confirm-password"
          placeholder="Confirm Password"
          confirmValue={password}
          value={confirmPassword}
          onChange={changeConfirmPassword}
          onError={changeError('confirmPassword')}
        />
      </div>
      <div>
        <LaddaButton
          className="button"
          loading={showLoader}
          onClick={submit}
          data-color="#000000"
          data-size={XL}
          data-style={SLIDE_UP}
          data-spinner-size={30}
          data-spinner-color="#000000"
          data-spinner-lines={6}
        >
          {showLoader ? '' : 'Sign up'}
        </LaddaButton>
      </div>
    </div>
  );
};

Signup.propTypes = {
  account: PropTypes.shape({
    loading: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  signup: PropTypes.func.isRequired,
};

export default Signup;
